import { useContext } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Lottie from "lottie-react";
import intro from "@/assets/lottie/intro.json";
import { context } from "@/Layout";
import "./styles.scss";

const SiteIntro = () => {
  const { setIntroComplete, introShown } = useContext(context);

  const lottieCompleted = () => {
    // setTimeout(() => {
    setIntroComplete();
    // }, 100)
  };

  return (
    <AnimatePresence>
      {!introShown && (
        <motion.div
          key="intro"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="w-screen h-screen transition-opacity max-h-screen overflow-hidden max-w-full absolute top-0 intro-bg left-0 z-[60] flex items-center justify-center"
        >
          <motion.div
            key="intro"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <Lottie animationData={intro} loop={false} onComplete={() => lottieCompleted()} />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SiteIntro;
